import { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Eraser } from "lucide-react";

export const SignaturePad = ({ onChange, testId = "signature" }) => {
  const ref = useRef(null);
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(true);

  useEffect(() => {
    const cv = ref.current;
    const ratio = window.devicePixelRatio || 1;
    cv.width = cv.offsetWidth * ratio; cv.height = cv.offsetHeight * ratio;
    const ctx = cv.getContext("2d");
    ctx.scale(ratio, ratio); ctx.lineWidth = 2.2; ctx.lineCap = "round"; ctx.lineJoin = "round"; ctx.strokeStyle = "#0A2540";
  }, []);

  const pos = (e) => { const r = ref.current.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };
  const start = (e) => { e.preventDefault(); drawing.current = true; const ctx = ref.current.getContext("2d"); ctx.beginPath(); ctx.moveTo(...pos(e)); };
  const move = (e) => { if (!drawing.current) return; e.preventDefault(); const ctx = ref.current.getContext("2d"); ctx.lineTo(...pos(e)); ctx.stroke(); if (empty) setEmpty(false); };
  const end = () => { if (!drawing.current) return; drawing.current = false; onChange(ref.current.toDataURL("image/png")); };
  const clear = () => { const cv = ref.current; cv.getContext("2d").clearRect(0, 0, cv.width, cv.height); setEmpty(true); onChange(""); };

  return (
    <div className="space-y-2">
      <div className="relative">
        <canvas ref={ref} className="w-full h-36 bg-white border-2 border-dashed border-slate-300 rounded-lg touch-none cursor-crosshair"
          onPointerDown={start} onPointerMove={move} onPointerUp={end} onPointerLeave={end} onPointerCancel={end} data-testid={`${testId}-canvas`} />
        {empty && <span className="absolute inset-0 flex items-center justify-center text-sm text-slate-400 pointer-events-none">Podepište se prstem nebo myší</span>}
      </div>
      <Button type="button" variant="ghost" size="sm" onClick={clear} className="text-slate-500" data-testid={`${testId}-clear`}><Eraser className="h-4 w-4 mr-1" /> Smazat podpis</Button>
    </div>
  );
};
